import type { RouteObject } from 'react-router';
import { recordTabRoutes } from '../../shared/components/record-tab-routes';
import { CustomersPage } from './pages/CustomersPage';
import { CustomerDetailPage } from './pages/CustomerDetailPage';
import { CUSTOMER_TABS } from './customers.paths';

export const CUSTOMER_ROUTES: RouteObject[] = [
  { path: 'customers', element: <CustomersPage /> },
  ...recordTabRoutes('customers/:id', CUSTOMER_TABS, (tab) => <CustomerDetailPage tab={tab} />),
];
